import axios from "axios";

const baseUrl = `${process.env.REACT_APP_TOGETHER_BACKEND_HOST}`;

const togetherCustomerList = async (
  offset,
  pageSize,
  startDate,
  endDate,
  withdrawStatus,
  orderType,
  orderBy,
) => {
  const { data } = await axios.get(
    `${baseUrl}/partners/read/admin/userList?offset=${offset}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}&withdrawStatus&orderType=${orderType}&orderBy=${orderBy}`,
  );
  return data;
};

const CustomerManageApi = {
  togetherCustomerList,
};

export default CustomerManageApi;
